function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ideas--active"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 343"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse 46"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "white"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 38,
  height: 38
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse 47"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "white"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group 75"
}, /*#__PURE__*/React.createElement("g", {
  id: "Frame",
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M21.1948 25.1343C19.4986 25.1343 17.7819 25.1343 16.0499 25.1343C16.0295 24.7659 16.0397 24.3874 15.9784 24.0241C15.866 23.3795 15.7485 22.7349 15.5594 22.1159C15.4624 21.7884 15.2376 21.4866 15.023 21.2001C14.3895 20.3457 13.761 19.4965 13.3779 18.4835C12.5195 16.212 13.4238 13.7256 15.2069 12.3647C17.6082 10.5383 20.7605 10.835 22.8041 13.0503C24.3573 14.7334 24.669 17.1738 23.5501 19.2355C23.218 19.8443 22.8399 20.4429 22.3954 20.975C21.8232 21.6656 21.5218 22.4433 21.394 23.3079C21.3072 23.9013 21.2612 24.505 21.1948 25.1343ZM16.99 24.1571C18.0884 24.1571 19.1716 24.1571 20.2751 24.1571C20.3262 23.8297 20.3671 23.5125 20.4182 23.1953C20.5919 22.1517 20.9138 21.1694 21.6393 20.3559C21.9049 20.0592 22.1144 19.7164 22.3341 19.3839C23.0034 18.376 23.3764 17.2812 23.2027 16.0534C22.8501 13.5312 20.6532 11.8122 18.1191 12.0629C15.1814 12.3494 13.2552 15.4548 14.3128 18.2123C14.6194 19.0053 15.0741 19.7216 15.6208 20.3559C16.336 21.1899 16.6681 22.167 16.8418 23.2209C16.9031 23.5279 16.944 23.8399 16.99 24.1571Z",
  fill: "#C72921",
  stroke: "#C72921",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M16.0347 27.7891C16.0347 27.4668 16.0347 27.165 16.0347 26.8427C17.7667 26.8427 19.4833 26.8427 21.2204 26.8427C21.2204 27.1496 21.2204 27.4617 21.2204 27.7891C19.5037 27.7891 17.782 27.7891 16.0347 27.7891Z",
  fill: "#C72921",
  stroke: "#C72921",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M19.11 8.87674C18.7881 8.87674 18.4815 8.87674 18.1597 8.87674C18.1597 7.99678 18.1597 7.12706 18.1597 6.23688C18.4713 6.23688 18.783 6.23688 19.11 6.23688C19.11 7.1066 19.11 7.97632 19.11 8.87674Z",
  fill: "#C72921",
  stroke: "#C72921",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M25.3174 20.6322C25.4809 20.3457 25.6393 20.0745 25.8079 19.7829C26.5793 20.228 27.3406 20.668 28.1172 21.1182C27.9537 21.4047 27.8004 21.6707 27.6267 21.9674C26.8552 21.5223 26.094 21.0824 25.3174 20.6322Z",
  fill: "#C72921",
  stroke: "#C72921",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M11.9931 12.8201C11.8245 13.1118 11.6713 13.3829 11.5027 13.6694C10.7312 13.2243 9.98016 12.7894 9.19336 12.3341C9.35685 12.0527 9.51523 11.7765 9.68383 11.4849C10.4553 11.9351 11.2115 12.3699 11.9931 12.8201Z",
  fill: "#C72921",
  stroke: "#C72921",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M25.2974 12.7894C26.0739 12.3392 26.825 11.9043 27.6067 11.4541C27.7702 11.7406 27.9285 12.0117 28.0971 12.3034C27.3308 12.7485 26.5746 13.1833 25.7929 13.6386C25.6295 13.3573 25.4711 13.0861 25.2974 12.7894Z",
  fill: "#C72921",
  stroke: "#C72921",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M12.0137 20.668C11.2269 21.1233 10.4707 21.5582 9.70434 22.0033C9.54085 21.7168 9.38247 21.4507 9.21387 21.154C9.98534 20.7089 10.7466 20.2689 11.5232 19.8187C11.6867 20.1052 11.8399 20.3764 12.0137 20.668Z",
  fill: "#C72921",
  stroke: "#C72921",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  d: "M17.3374 30.224C17.3374 29.9017 17.3374 29.5998 17.3374 29.2827C18.2008 29.2827 19.0541 29.2827 19.9277 29.2827C19.9277 29.5896 19.9277 29.9017 19.9277 30.224C19.0694 30.224 18.2162 30.224 17.3374 30.224Z",
  fill: "#C72921",
  stroke: "#C72921",
  strokeWidth: 0.4
}))));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 14.1655,
  y1: 18.9967,
  x2: 39.846,
  y2: 18.9967,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C800CA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 32.8453,
  y1: -3.12632,
  x2: 17.8651,
  y2: 33.1345,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#003FBF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#1E39C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#3B33C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#532ECA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#662ACC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#7327CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#7B25CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 14.1655,
  y1: 18.9967,
  x2: 39.846,
  y2: 18.9967,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C800CA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 32.8453,
  y1: -3.12632,
  x2: 17.8651,
  y2: 33.1345,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#003FBF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#1E39C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#3B33C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#532ECA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#662ACC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#7327CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#7B25CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.073,
  height: 26.1305,
  fill: "white",
  transform: "translate(8.44434 6.33331)"
})));

function SvgIdeasActive(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImlkZWFzLS1hY3RpdmUiPgo8ZyBpZD0iR3JvdXAgMzQzIj4KPGcgaWQ9IkVsbGlwc2UgNDYiPgo8Y2lyY2xlIGN4PSIxOSIgY3k9IjE5IiByPSIxOSIgZmlsbD0iI0M0QzRDNCIvPgo8Y2lyY2xlIGN4PSIxOSIgY3k9IjE5IiByPSIxOSIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIvPgo8Y2lyY2xlIGN4PSIxOSIgY3k9IjE5IiByPSIxOSIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyKSIvPgo8Y2lyY2xlIGN4PSIxOSIgY3k9IjE5IiByPSIxOSIgZmlsbD0id2hpdGUiLz4KPC9nPgo8bWFzayBpZD0ibWFzazAiIG1hc2stdHlwZT0iYWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIzOCIgaGVpZ2h0PSIzOCI+CjxnIGlkPSJFbGxpcHNlIDQ3Ij4KPGNpcmNsZSBjeD0iMTkiIGN5PSIxOSIgcj0iMTkiIGZpbGw9IiNDNEM0QzQiLz4KPGNpcmNsZSBjeD0iMTkiIGN5PSIxOSIgcj0iMTkiIGZpbGw9InVybCgjcGFpbnQyX2xpbmVhcikiLz4KPGNpcmNsZSBjeD0iMTkiIGN5PSIxOSIgcj0iMTkiIGZpbGw9InVybCgjcGFpbnQzX2xpbmVhcikiLz4KPGNpcmNsZSBjeD0iMTkiIGN5PSIxOSIgcj0iMTkiIGZpbGw9IndoaXRlIi8+CjwvZz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CjwvZz4KPC9nPgo8ZyBpZD0iR3JvdXAgNzUiPgo8ZyBpZD0iRnJhbWUiIGNsaXAtcGF0aD0idXJsKCNjbGlwMCkiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMjEuMTk0OCAyNS4xMzQzQzE5LjQ5ODYgMjUuMTM0MyAxNy43ODE5IDI1LjEzNDMgMTYuMDQ5OSAyNS4xMzQzQzE2LjAyOTUgMjQuNzY1OSAxNi4wMzk3IDI0LjM4NzQgMTUuOTc4NCAyNC4wMjQxQzE1Ljg2NiAyMy4zNzk1IDE1Ljc0ODUgMjIuNzM0OSAxNS41NTk0IDIyLjExNTlDMTUuNDYyNCAyMS43ODg0IDE1LjIzNzYgMjEuNDg2NiAxNS4wMjMgMjEuMjAwMUMxNC4zODk1IDIwLjM0NTcgMTMuNzYxIDE5LjQ5NjUgMTMuMzc3OSAxOC40ODM1QzEyLjUxOTUgMTYuMjEyIDEzLjQyMzggMTMuNzI1NiAxNS4yMDY5IDEyLjM2NDdDMTcuNjA4MiAxMC41MzgzIDIwLjc2MDUgMTAuODM1IDIyLjgwNDEgMTMuMDUwM0MyNC4zNTczIDE0LjczMzQgMjQuNjY5IDE3LjE3MzggMjMuNTUwMSAxOS4yMzU1QzIzLjIxOCAxOS44NDQzIDIyLjgzOTkgMjAuNDQyOSAyMi4zOTU0IDIwLjk3NUMyMS44MjMyIDIxLjY2NTYgMjEuNTIxOCAyMi40NDMzIDIxLjM5NCAyMy4zMDc5QzIxLjMwNzIgMjMuOTAxMyAyMS4yNjEyIDI0LjUwNSAyMS4xOTQ4IDI1LjEzNDNaTTE2Ljk5IDI0LjE1NzFDMTguMDg4NCAyNC4xNTcxIDE5LjE3MTYgMjQuMTU3MSAyMC4yNzUxIDI0LjE1NzFDMjAuMzI2MiAyMy44Mjk3IDIwLjM2NzEgMjMuNTEyNSAyMC40MTgyIDIzLjE5NTNDMjAuNTkxOSAyMi4xNTE3IDIwLjkxMzggMjEuMTY5NCAyMS42MzkzIDIwLjM1NTlDMjEuOTA0OSAyMC4wNTkyIDIyLjExNDQgMTkuNzE2NCAyMi4zMzQxIDE5LjM4MzlDMjMuMDAzNCAxOC4zNzYgMjMuMzc2NCAxNy4yODEyIDIzLjIwMjcgMTYuMDUzNEMyMi44NTAxIDEzLjUzMTIgMjAuNjUzMiAxMS44MTIyIDE4LjExOTEgMTIuMDYyOUMxNS4xODE0IDEyLjM0OTQgMTMuMjU1MiAxNS40NTQ4IDE0LjMxMjggMTguMjEyM0MxNC42MTk0IDE5LjAwNTMgMTUuMDc0MSAxOS43MjE2IDE1LjYyMDggMjAuMzU1OUMxNi4zMzYgMjEuMTg5OSAxNi42NjgxIDIyLjE2NyAxNi44NDE4IDIzLjIyMDlDMTYuOTAzMSAyMy41Mjc5IDE2Ljk0NCAyMy44Mzk5IDE2Ljk5IDI0LjE1NzFaIiBmaWxsPSIjQzcyOTIxIiBzdHJva2U9IiNDNzI5MjEiIHN0cm9rZS13aWR0aD0iMC40Ii8+CjxwYXRoIGlkPSJWZWN0b3JfMiIgZD0iTTE2LjAzNDcgMjcuNzg5MUMxNi4wMzQ3IDI3LjQ2NjggMTYuMDM0NyAyNy4xNjUgMTYuMDM0NyAyNi44NDI3QzE3Ljc2NjcgMjYuODQyNyAxOS40ODMzIDI2Ljg0MjcgMjEuMjIwNCAyNi44NDI3QzIxLjIyMDQgMjcuMTQ5NiAyMS4yMjA0IDI3LjQ2MTcgMjEuMjIwNCAyNy43ODkxQzE5LjUwMzcgMjcuNzg5MSAxNy43ODIgMjcuNzg5MSAxNi4wMzQ3IDI3Ljc4OTFaIiBmaWxsPSIjQzcyOTIxIiBzdHJva2U9IiNDNzI5MjEiIHN0cm9rZS13aWR0aD0iMC40Ii8+CjxwYXRoIGlkPSJWZWN0b3JfMyIgZD0iTTE5LjExIDguODc2NzRDMTguNzg4MSA4Ljg3Njc0IDE4LjQ4MTUgOC44NzY3NCAxOC4xNTk3IDguODc2NzRDMTguMTU5NyA3Ljk5Njc4IDE4LjE1OTcgNy4xMjcwNiAxOC4xNTk3IDYuMjM2ODhDMTguNDcxMyA2LjIzNjg4IDE4Ljc4MyA2LjIzNjg4IDE5LjExIDYuMjM2ODhDMTkuMTEgNy4xMDY2IDE5LjExIDcuOTc2MzIgMTkuMTEgOC44NzY3NFoiIGZpbGw9IiNDNzI5MjEiIHN0cm9rZT0iI0M3MjkyMSIgc3Ryb2tlLXdpZHRoPSIwLjQiLz4KPHBhdGggaWQ9IlZlY3Rvcl80IiBkPSJNMjUuMzE3NCAyMC42MzIyQzI1LjQ4MDkgMjAuMzQ1NyAyNS42MzkzIDIwLjA3NDUgMjUuODA3OSAxOS43ODI5QzI2LjU3OTMgMjAuMjI4IDI3LjM0MDYgMjAuNjY4IDI4LjExNzIgMjEuMTE4MkMyNy45NTM3IDIxLjQwNDcgMjcuODAwNCAyMS42NzA3IDI3LjYyNjcgMjEuOTY3NEMyNi44NTUyIDIxLjUyMjMgMjYuMDk0IDIxLjA4MjQgMjUuMzE3NCAyMC42MzIyWiIgZmlsbD0iI0M3MjkyMSIgc3Ryb2tlPSIjQzcyOTIxIiBzdHJva2Utd2lkdGg9IjAuNCIvPgo8cGF0aCBpZD0iVmVjdG9yXzUiIGQ9Ik0xMS45OTMxIDEyLjgyMDFDMTEuODI0NSAxMy4xMTE4IDExLjY3MTMgMTMuMzgyOSAxMS41MDI3IDEzLjY2OTRDMTAuNzMxMiAxMy4yMjQzIDkuOTgwMTYgMTIuNzg5NCA5LjE5MzM2IDEyLjMzNDFDOS4zNTY4NSAxMi4wNTI3IDkuNTE1MjMgMTEuNzc2NSA5LjY4MzgzIDExLjQ4NDlDMTAuNDU1MyAxMS45MzUxIDExLjIxMTUgMTIuMzY5OSAxMS45OTMxIDEyLjgyMDFaIiBmaWxsPSIjQzcyOTIxIiBzdHJva2U9IiNDNzI5MjEiIHN0cm9rZS13aWR0aD0iMC40Ii8+CjxwYXRoIGlkPSJWZWN0b3JfNiIgZD0iTTI1LjI5NzQgMTIuNzg5NEMyNi4wNzM5IDEyLjMzOTIgMjYuODI1IDExLjkwNDMgMjcuNjA2NyAxMS40NTQxQzI3Ljc3MDIgMTEuNzQwNiAyNy45Mjg1IDEyLjAxMTcgMjguMDk3MSAxMi4zMDM0QzI3LjMzMDggMTIuNzQ4NSAyNi41NzQ2IDEzLjE4MzMgMjUuNzkyOSAxMy42Mzg2QzI1LjYyOTUgMTMuMzU3MyAyNS40NzExIDEzLjA4NjEgMjUuMjk3NCAxMi43ODk0WiIgZmlsbD0iI0M3MjkyMSIgc3Ryb2tlPSIjQzcyOTIxIiBzdHJva2Utd2lkdGg9IjAuNCIvPgo8cGF0aCBpZD0iVmVjdG9yXzciIGQ9Ik0xMi4wMTM3IDIwLjY2OEMxMS4yMjY5IDIxLjEyMzMgMTAuNDcwNyAyMS41NTgyIDkuNzA0MzQgMjIuMDAzM0M5LjU0MDg1IDIxLjcxNjggOS4zODI0NyAyMS40NTA3IDkuMjEzODcgMjEuMTU0QzkuOTg1MzQgMjAuNzA4OSAxMC43NDY2IDIwLjI2ODkgMTEuNTIzMiAxOS44MTg3QzExLjY4NjcgMjAuMTA1MiAxMS44Mzk5IDIwLjM3NjQgMTIuMDEzNyAyMC42NjhaIiBmaWxsPSIjQzcyOTIxIiBzdHJva2U9IiNDNzI5MjEiIHN0cm9rZS13aWR0aD0iMC40Ii8+CjxwYXRoIGlkPSJWZWN0b3JfOCIgZD0iTTE3LjMzNzQgMzAuMjI0QzE3LjMzNzQgMjkuOTAxNyAxNy4zMzc0IDI5LjU5OTggMTcuMzM3NCAyOS4yODI3QzE4LjIwMDggMjkuMjgyNyAxOS4wNTQxIDI5LjI4MjcgMTkuOTI3NyAyOS4yODI3QzE5LjkyNzcgMjkuNTg5NiAxOS45Mjc3IDI5LjkwMTcgMTkuOTI3NyAzMC4yMjRDMTkuMDY5NCAzMC4yMjQgMTguMjE2MiAzMC4yMjQgMTcuMzM3NCAzMC4yMjRaIiBmaWxsPSIjQzcyOTIxIiBzdHJva2U9IiNDNzI5MjEiIHN0cm9rZS13aWR0aD0iMC40Ii8+CjwvZz4KPC9nPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSIxNC4xNjU1IiB5MT0iMTguOTk2NyIgeDI9IjM5Ljg0NiIgeTI9IjE4Ljk5NjciIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0M4MDBDQSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM3RDI1Q0YiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyIiB4MT0iMzIuODQ1MyIgeTE9Ii0zLjEyNjMyIiB4Mj0iMTcuODY1MSIgeTI9IjMzLjEzNDUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzAwM0ZCRiIvPgo8c3RvcCBvZmZzZXQ9IjAuMDciIHN0b3AtY29sb3I9IiMxRTM5QzMiLz4KPHN0b3Agb2Zmc2V0PSIwLjE2IiBzdG9wLWNvbG9yPSIjM0IzM0M3Ii8+CjxzdG9wIG9mZnNldD0iMC4yNiIgc3RvcC1jb2xvcj0iIzUzMkVDQSIvPgo8c3RvcCBvZmZzZXQ9IjAuMzciIHN0b3AtY29sb3I9IiM2NjJBQ0MiLz4KPHN0b3Agb2Zmc2V0PSIwLjUiIHN0b3AtY29sb3I9IiM3MzI3Q0UiLz4KPHN0b3Agb2Zmc2V0PSIwLjY2IiBzdG9wLWNvbG9yPSIjN0IyNUNGIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzdEMjVDRiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50Ml9saW5lYXIiIHgxPSIxNC4xNjU1IiB5MT0iMTguOTk2NyIgeDI9IjM5Ljg0NiIgeTI9IjE4Ljk5NjciIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0M4MDBDQSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM3RDI1Q0YiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDNfbGluZWFyIiB4MT0iMzIuODQ1MyIgeTE9Ii0zLjEyNjMyIiB4Mj0iMTcuODY1MSIgeTI9IjMzLjEzNDUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzAwM0ZCRiIvPgo8c3RvcCBvZmZzZXQ9IjAuMDciIHN0b3AtY29sb3I9IiMxRTM5QzMiLz4KPHN0b3Agb2Zmc2V0PSIwLjE2IiBzdG9wLWNvbG9yPSIjM0IzM0M3Ii8+CjxzdG9wIG9mZnNldD0iMC4yNiIgc3RvcC1jb2xvcj0iIzUzMkVDQSIvPgo8c3RvcCBvZmZzZXQ9IjAuMzciIHN0b3AtY29sb3I9IiM2NjJBQ0MiLz4KPHN0b3Agb2Zmc2V0PSIwLjUiIHN0b3AtY29sb3I9IiM3MzI3Q0UiLz4KPHN0b3Agb2Zmc2V0PSIwLjY2IiBzdG9wLWNvbG9yPSIjN0IyNUNGIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzdEMjVDRiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjIxLjA3MyIgaGVpZ2h0PSIyNi4xMzA1IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC40NDQzNCA2LjMzMzMxKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgIdeasActive as ReactComponent };